import { createDerived, createStore, update } from '@kundinos/nanostores';
import { useStore } from '@kundinos/nanostores/react';

import type { SelectedOption } from '@Pages/PageProduct';

function transformData(data: SelectedOption[]) {
  const result = {};

  data.forEach((item) => {
    const { tabId, id, count } = item;

    // Проверяем, существует ли уже ключ tabId в результате
    if (!result[tabId]) {
      result[tabId] = [];
    }

    result[tabId].push(count > 1 ? `${id}-${count}` : id);
  });

  // Преобразуем массивы в строки
  for (const tab in result) {
    result[tab] = Array.from(new Set(result[tab])).join(', ');
  }

  return result;
}

export const selectedParamsStore = createStore<SelectedOption[]>(() => {
  selectedParamsStore.set([]);
});

export const activeMobilePanelStore = createStore<boolean>(() => {
  activeMobilePanelStore.set(false);
});

export const set = (selectedOption: SelectedOption[]) => {
  update(selectedParamsStore, () => selectedOption);
};

interface Props {
  option: SelectedOption;
  overwrite?: boolean;
}

export const change = (props: Props) => {
  const { option, overwrite = true } = props;
  const { parameterId, id, count } = option;

  update(selectedParamsStore, (prev: SelectedOption[]) => {
    // Если count === 0, удаляем все параметры с таким id
    if (count === 0) {
      return prev.filter((param) => param.id !== id);
    }

    // Ищем индекс параметра с таким parameterId
    const existingIndex = prev.findIndex((param) => param.parameterId === parameterId);

    if (existingIndex !== -1) {
      if (overwrite) {
        // Обновляем параметр по parameterId
        return [...prev.slice(0, existingIndex), option, ...prev.slice(existingIndex + 1)];
      }
      // Если overwrite = false, обновляем параметр по id, если он есть
      const updated = prev.map((param) => (param.id === id ? option : param));

      // Если параметр с таким id не найден, добавляем новый
      const hasId = prev.some((param) => param.id === id);
      if (!hasId) {
        return [...updated, option];
      }

      return updated;
    }

    // Если параметр с таким parameterId не найден, добавляем новый
    return [...prev, option];
  });
};

export const selectedParamsObjectStore = createDerived(selectedParamsStore, (data) => {
  if (!data) return {};

  return transformData([...(data || [])]);
});

export const changePanelView = (val: boolean) => {
  update(activeMobilePanelStore, () => val);
};

export const useSelectedParams = () => {
  return useStore(selectedParamsStore);
};

export const useSelectedParamsObject = () => {
  return useStore(selectedParamsObjectStore);
};

export const useActiveMobilePanel = () => {
  return useStore(activeMobilePanelStore);
};
